import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PropertyPortfolioCard = ({ property, onClick }) => {
  const formatCurrency = (amount, currency) => {
    const formatted = new Intl.NumberFormat('ar-EG')?.format(amount);
    return `${formatted} ${currency || 'دينار'}`;
  };

  const getStatusColor = (status) => {
    const colors = {
      'متاح': 'bg-success/10 text-success border-success/20',
      'محجوز': 'bg-warning/10 text-warning border-warning/20',
      'مؤجر': 'bg-primary/10 text-primary border-primary/20',
      'مباع': 'bg-blue-500/10 text-blue-500 border-blue-500/20'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground border-border';
  };

  const mainImage = property?.images?.[0] || '/assets/images/no_image.png';

  return (
    <div 
      onClick={onClick}
      className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-warm-md transition-all duration-250 cursor-pointer group"
    >
      {/* Property Image */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src={mainImage}
          alt={property?.title || 'عقار'}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 right-3">
          <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(property?.status)}`}>
            {property?.status}
          </span>
        </div>
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 rounded-full text-xs font-semibold bg-black/70 text-white border border-white/20">
            {property?.type}
          </span>
        </div>
      </div>

      {/* Property Details */}
      <div className="p-4" dir="rtl">
        <h3 className="text-lg font-bold text-foreground mb-2 line-clamp-1">
          {property?.title}
        </h3>
        
        <div className="flex items-center gap-2 text-muted-foreground text-sm mb-3">
          <Icon name="MapPin" size={14} color="var(--color-primary)" />
          <span className="line-clamp-1">{property?.address}, {property?.city}</span>
        </div>

        {/* Specifications */}
        <div className="grid grid-cols-3 gap-2 mb-3">
          {property?.bedrooms && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="Bed" size={14} color="var(--color-muted-foreground)" />
              <span>{property?.bedrooms} غرف</span>
            </div>
          )}
          {property?.bathrooms && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="Bath" size={14} color="var(--color-muted-foreground)" />
              <span>{property?.bathrooms} حمام</span>
            </div>
          )}
          {property?.area && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="Maximize" size={14} color="var(--color-muted-foreground)" />
              <span>{property?.area} م²</span>
            </div>
          )}
        </div>

        {/* Price */}
        <div className="flex items-center justify-between pt-3 border-t border-border">
          <div>
            <p className="text-xs text-muted-foreground mb-1">القيمة الحالية</p>
            <p className="text-lg font-bold text-primary">
              {formatCurrency(property?.price, property?.currency)}
            </p>
          </div>
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="TrendingUp" size={18} color="var(--color-primary)" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyPortfolioCard;